import moment from "moment";
import translate from "../translations/i18n";

export function calculateSmokeless(startDate) {
  const days = 90 - daysInProgram(startDate);
  const daysString =
    days > 0
      ? translate("DAYS_LEFT_LONG", { days: `${days}` }).toUpperCase()
      : translate("DAYS_SINCE_LONG", { days: `${-days}` }).toUpperCase();
  return daysString;
}

function daysInProgram(start): number {
  const start_date = moment(start).startOf("day");
  const today = moment(new Date()).startOf("day");
  const duration = today.diff(start_date, "day");
  return duration;
}



// WEBPACK FOOTER //
// ./src/functions/calculateSmokeless.tsx